<template>
  <div>
    <div style=" background-color: #fff;">
      <div class="container">

        <div class="con-main" style="padding-top: 4.7rem;">
          <div class="h2-title">省级服务专区
            <span class="bot-line"></span>
          </div>
        </div>
        <div class="con-province">
          <ComMap />
        </div>
        <div class="con-info">
          <div class="service-center">
            <h2 class="section-title">全国服务中心</h2>
            <div class="faq-section">
              <h3 class="faq-title">常见问题：</h3>
              <ul class="faq-list">
                <li class="faq-item" v-for="item in questions" :key="item.id" @click="goQuestionDetail(item)">{{
                  item.title }}</li>

              </ul>
            </div>

            <div class="online-platforms">
              <div class="platform">
                <div class="platform-icon qq-icon">

                  <img src="/img/icon_qq.jpg" />

                </div>
                <div class="platform-text"><a href="https://wpa1.qq.com/QPNgqRWc?_type=wpa&qidian=true" target="_blank">
                    <span>全国QQ服务平台-在线交谈</span>
                    <span class="platform-subtext">800110244</span>
                  </a></div>
              </div>

              <div class="platform" style="margin-right: 0;">
                <div class="platform-icon wechat-icon">

                  <img src="/img/icon_wechat.jpg" />

                </div>
                <div class="platform-text"><a href="https://wpa1.qq.com/VgEx7FPF?_type=wpa&qidian=true"
                    target="_blank">全国微信服务平台-在线交谈</a></div>
              </div>
            </div>

            <div class="contact-info">
              <div class="contact-item">
                <div class="contact-label">技术支持服务热线：</div>
                <div class="contact-value">
                  010-88614688【call center】<br>
                  <span class="call-center">工作日（08:30至17:30）</span>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-label">安全产品服务热线：</div>
                <div class="contact-value">010-88613588</div>
              </div>

              <div class="contact-item">
                <div class="contact-label">地址：</div>
                <div class="contact-value">北京市海淀区莲花苑838室</div>
              </div>

              <div class="contact-item">
                <div class="contact-label">邮箱：</div>
                <div class="contact-value">3088873564@qq.com</div>
              </div>
            </div>
          </div>

          <!-- 右侧：省级微信服务群 -->
          <div class="wechat-groups">
            <h2 class="section-title">省级微信服务群</h2>
            <div class="province-grid">
              <div class="province-item" v-for="(item, index) in privinceInfo" :key="index">

                <el-popover
                  popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px; width: 10rem">
                  <template #reference>
                    <span class="province-item-trigger">{{ item.linkName }}</span>
                  </template>
                  <template #default>
                    <img style="width: 100%; height: 100%;" :src="item.wechatQrcode" />
                  </template>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div style="width: 100%;  background-color: #eef4f7;  padding-top: 1.875rem;">
      <!---------跨省通办----------->
      <div class="con-main">
        <div class="h2-title">“跨省通办”服务专区
          <span class="bot-line"></span>
        </div>
        <div class="sys-banner" v-for="(item, index) in kuaSheng" :key="index">
          <div class="title">{{ item.text }}</div>
          <ul>
            <li><img src="/img/ico01.jpg" /><a @click="router.push('/serviceGuide')" style="cursor: pointer;">服务指南</a>
            </li>
            <li><img src="/img/ico02.jpg" /><a @click="onLineProcess(item)" target="_blank"
                style="cursor: pointer;">在线办理</a>
            </li>
          </ul>
        </div>
      </div>
      <!---------跨省通办----------->
      <div class="con-main">
        <div class="h2-title">国家级服务专区
          <span class="bot-line"></span>
        </div>
        <div class="sys-banner" v-for="(item, index) in fuwu" :key="index">
          <div class="title">{{ item.text }}</div>
          <ul>
            <li><img src="/img/ico01.jpg" /><a @click="router.push('/serviceGuide')" style="cursor: pointer;">服务指南</a>
            </li>
            <li><img src="/img/ico02.jpg" /><a @click="onLineProcess(item)" style="cursor: pointer;">在线办理</a>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <!---------注册测绘师执业系统----------->
    <div class="con-main">
      <div class="h2-title h2-title--clickable" @click="goCehuishi">注册测绘师执业系统
        <span class="bot-line"></span>
      </div>

    </div>
    <div style="max-width:1166px; width: 100%; margin: 0 auto;"><img style="width:100%; cursor: pointer;"
        @click="goCehuishi" src="/img/cehuishi.jpg" />
    </div>
    <!---------地理信息数据保密检查系统----------->
    <div class="con-main">
      <div class="h2-title h2-title--clickable" @click="goProduct">测绘地理信息行业监督检查（三检）系统
        <span class="bot-line"></span>
      </div>

    </div>
    <div style="max-width:1166px; width: 100%; margin: 0 auto;"><img style="width:100%; cursor: pointer;"
        @click="goProduct" src="/img/banner_dili.jpg" />
    </div>
  </div>

</template>
<script setup>
import { getToken, setToken, removeToken } from "@/utils/auth";
import { ref } from 'vue'
import { getHotQuestions, getProvinces } from '@/api/home'
import ComMap from "@/components/comMap.vue";
import { useRouter } from 'vue-router'
import { ElMessageBox } from "element-plus";
const router = useRouter()
const token = getToken()
const kuaSheng = [
  {
    id: 'kuasheng',
    text: '测绘作业证管理信息系统',
    url: 'https://chzyz.cehuifuwu.cn/login'
  },

  {
    id: 'huice',
    text: '测绘项目备案管理信息系统',
    url: 'https://smpr.cehuifuwu.cn/login',
  }
]

const fuwu = [
  { id: 1, text: '从事测绘活动的单位甲级测绘资质审批（导航电子地图制作）', url: 'https://zz.ch.mnr.gov.cn/' },
  { id: 2, text: '国家测绘地理信息质量信息系统', url: 'http://124.207.179.248:8088/Login.aspx' },
  { id: 3, text: '中国测绘地理信息协会', url: 'https://cagis.cehuifuwu.cn/' },
  { id: 4, text: '中国测绘学会综合服务平台', url: 'https://fw.csgpc.org/Csgpc/Login.aspx?r=230842', outLink: true },
]
let questions = ref([])

let privinceInfo = ref([])

/** 去掉省/市/自治区等后缀，便于与接口里的简称比较 */
function simplifyRegionName(name) {
  if (!name || typeof name !== "string") return "";
  return name
    .replace(/省|市|壮族自治区|回族自治区|维吾尔自治区|自治区|特别行政区/g, "")
    .trim();
}

/**
 * 经纬度逆地理得到省级名称（Geolocation 本身不返回省名，需逆地理服务）
 * 使用 BigDataCloud 浏览器端免费接口，无需 key
 */
async function reverseGeocodeToProvinceName(latitude, longitude) {
  const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${encodeURIComponent(
    latitude
  )}&longitude=${encodeURIComponent(longitude)}&localityLanguage=zh`;
  const res = await fetch(url);
  if (!res.ok) return "";
  const data = await res.json();
  if (data.principalSubdivision) return String(data.principalSubdivision);
  const admin = data.localityInfo?.administrative;
  if (Array.isArray(admin)) {
    const hit = admin.find((x) => x.name && /省|市|自治区|特别行政区/.test(x.name));
    if (hit) return hit.name;
  }
  return data.city ? String(data.city) : "";
}

/**
 * 将逆地理得到的省名与 getProvinces 列表匹配，返回完整省份项
 */
function matchProvinceFromList(geocodeProvinceName, provinceList) {
  if (!geocodeProvinceName || !Array.isArray(provinceList)) return null;
  const g = simplifyRegionName(geocodeProvinceName);
  if (!g) return null;
  for (const item of provinceList) {
    const link = simplifyRegionName(item.linkName || "");
    const area = simplifyRegionName(item.areaName || "");
    if (
      link &&
      (g.includes(link) || link.includes(g) || geocodeProvinceName.includes(item.linkName))
    ) {
      return item;
    }
    if (
      area &&
      (g.includes(area) || area.includes(g) || geocodeProvinceName.includes(item.areaName))
    ) {
      return item;
    }
  }
  return null;
}

/** 定位失败且无省份缓存时，默认北京 */
const BEIJING_FALLBACK_PROVINCE = {
  id: 1,
  linkName: "北京",
  linkCode: "BJ",
  loginUrl: "/bj",
  linkIcon: "北京.jpg",
  areaId: 2,
  areaName: "北京市",
  wechatQrcode:
    "http://cehuifuwu.cn/files/2025/5/9/1FF159A9F0B84EFA8057690CF3F1DF84.jpg",
};

function storeDefaultBeijingIfEmpty() {
  if (sessionStorage.getItem("provinceInfo")) return;
  sessionStorage.setItem(
    "provinceInfo",
    JSON.stringify(BEIJING_FALLBACK_PROVINCE)
  );
}

/**
 * 通过 Geolocation + 逆地理 + getProvinces 数据匹配，写入 sessionStorage.provinceInfo
 * 若已有 provinceInfo（例如用户从地图点选），则不覆盖
 */
function detectAndStoreProvinceByGeolocation(provinceList) {
  if (!provinceList?.length) return;
  if (!navigator.geolocation) {
    console.warn("[定位] 当前浏览器不支持 Geolocation API");
    storeDefaultBeijingIfEmpty();
    return;
  }
  // 非 HTTPS（非 localhost）时，多数浏览器会拒绝定位，getCurrentPosition 只走 error 回调
  if (typeof window.isSecureContext !== "undefined" && !window.isSecureContext) {
    console.warn(
      "[定位] 需要在 HTTPS 或 localhost 下访问，当前页面非安全上下文，浏览器不会提供位置"
    );
  }

  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      try {
        const { latitude, longitude } = pos.coords;
        const provinceName = await reverseGeocodeToProvinceName(latitude, longitude);
        const matched = matchProvinceFromList(provinceName, provinceList);
        if (matched) {
          sessionStorage.setItem("provinceInfo", JSON.stringify(matched));
        } else if (!sessionStorage.getItem("provinceInfo")) {
          storeDefaultBeijingIfEmpty();
        }
      } catch (e) {
        console.warn("[定位] 逆地理或匹配失败", e);
        storeDefaultBeijingIfEmpty();
      }
    },
    (err) => {
      const map = { 1: "用户拒绝授权", 2: "位置不可用", 3: "请求超时" };
      console.warn(
        "[定位] getCurrentPosition 失败:",
        map[err.code] || err.message,
        "（code=",
        err.code,
        "）"
      );
      storeDefaultBeijingIfEmpty();
    },
    { enableHighAccuracy: false, timeout: 12000, maximumAge: 300000 }
  );
}

/** 与 comMap 等页面一致：兼容 success 或仅 code===200 的接口返回 */
function normalizeProvinceResponse(res) {
  if (!res) return [];
  const ok = res.success === true || res.code === 200;
  if (!ok) return [];
  const raw = res.data;
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.records)) return raw.records;
  if (Array.isArray(raw?.list)) return raw.list;
  return [];
}

function getProvinceList() {
  getProvinces()
    .then((res) => {
      const list = normalizeProvinceResponse(res);
      if (list.length) {
        privinceInfo.value = list;
        if (!sessionStorage.getItem("provinceInfo")) {
          detectAndStoreProvinceByGeolocation(list);
        }
      }
    })
    .catch(() => { });
}
getProvinceList()
function getQuestions() {
  getHotQuestions().then(res => {
    questions.value = res.data
  })
}
getQuestions()


function goQuestionDetail(data) {
  router.push('/article?id=' + data.id + "&type=cjwt")
}

function onLineProcess(item) {
  console.log('item', item)

  if (item.id === 3) {
    ElMessageBox.alert(
      `
      <div style="display:flex;flex-direction:column;gap:10px;line-height:1.8;">
        <a href="https://cagis.cehuifuwu.cn/login" target="_blank" rel="noopener noreferrer">中国地理信息产业协会综合业务系统</a>
        <a href="https://cagis.cehuifuwu.cn/jclogin" target="_blank" rel="noopener noreferrer">中国地理信息产业协会产业经济运行监测系统</a>
        <a href="https://cagis.cehuifuwu.cn/pxlogin" target="_blank" rel="noopener noreferrer">中国地理信息产业协会培训报名系统</a>
      </div>
      `,
      "请选择办理系统",
      {
        confirmButtonText: "关闭",
        dangerouslyUseHTMLString: true,
      }
    );
    return;
  }

  // 检查是否已登录
  if (!token && ['huice', 'kuasheng'].includes(item.id)) {
    // 未登录，显示省份选择弹窗
    const provinceList = privinceInfo.value.map(province => {
      return `<a href="/detail/${province.linkCode.toLowerCase()}" style="display:inline-block;padding:5px 10px;margin:5px;background:#f0f5ff;color:#2a6fdb;border-radius:4px;text-decoration:none;" target="_blank">${province.linkName}</a>`;
    }).join('');

    ElMessageBox.alert(
      `
      <div style="max-height:400px;overflow-y:auto;">
        ${provinceList}
      </div>
      `,
      "请先选择您的省份，再办理相关业务",
      {
        confirmButtonText: "关闭",
        dangerouslyUseHTMLString: true,
      }
    );
    return;
  }

  // 已登录，跳转到对应链接（占位链接）
  if (item.url) {
    window.open(item.url)
  }
}

function goProduct() {
  router.push({ name: "geoDataSecurityCheck" })
}

function goCehuishi() {
  router.push({ name: "cehuishi" })
}

</script>
<style lang="scss">
.container {
  width: 100%;
  background-color: #f1f5f8;
  padding-bottom: 1rem;
}

.con-main {
  max-width: 1166px;
  width: 100%;
  margin: 0 auto;
  padding-top: 2.375rem;

  .h2-title {
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: 3px;
    font-family: "微软雅黑", "Microsoft YaHei";
    margin-bottom: 2.1875rem;
    color: #000;

    .bot-line {
      width: 4.625rem;
      height: 2px;
      display: block;
      margin-top: 1.4375rem;
      background-color: #8db4e6;
    }

    &.h2-title--clickable {
      cursor: pointer;

      &:hover {
        color: #2a6fdb;
      }
    }
  }

}

// 主容器样式
.con-info {
  max-width: 1166px;
  width: 100%;
  margin: 0 auto;
  margin-top: 6.8rem;
  display: flex;
  align-items: stretch;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  overflow: visible;
  height: 100%;

  // 左侧全国服务中心样式
  .service-center {
    float: left;
    background-color: #fff;
    padding: 2.2rem 2.5rem;
    border-right: 1px solid #eaeaea;
    font-weight: bold;
    width: 50%;
    min-height: 30rem;
    height: auto;
    box-sizing: border-box;

    .section-title {
      color: #2a6fdb;
      font-size: 1.375rem;
      font-weight: 600;
      margin-bottom: 1.56rem;
      padding-bottom: 0.7rem;
      border-bottom: 1px solid #f0f0f0;
    }

    .faq-section {
      margin-bottom: 1.275rem;

      .faq-title {
        font-weight: 600;
        color: #333;
        margin-bottom: 0.24rem;
        font-size: 1rem;
      }

      .faq-list {
        list-style-type: none;
        display: flex;
        flex-wrap: wrap;

        .faq-item {
          padding: 0.5rem 1.125rem 0.625rem 0;
          color: #666;
          font-size: 0.9rem;
          position: relative;
          color: #2a6fdb;
          text-decoration: underline;

          &:hover {

            font-weight: 500;
            cursor: pointer;

          }
        }
      }
    }

    .online-platforms {
      display: flex;
      gap: 15px;
      margin-bottom: 35px;

      .platform {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 0;
        margin-right: 2px;

        &:hover {

          .platform-text,
          .platform-text a {
            color: #e60012;
          }

          .platform-icon img {
            animation: icon-flip-once 0.55s ease-in-out;
          }
        }

        .platform-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;

          // 特定平台图标样式
          &.qq-icon {
            background-color: #2a6fdb;
          }

          &.wechat-icon {
            background-color: #07c160;
          }

          img {
            transition: transform 0.2s ease;
            transform-origin: center center;
          }
        }

        .platform-text {
          color: #2a6fdb;
          font-weight: 500;
          font-size: 16px;
          line-height: 1.45;

          a {
            display: inline-flex;
            flex-direction: column;
            color: inherit;
            transition: color 0.2s ease;
          }

          .platform-subtext {
            margin-top: 2px;
            letter-spacing: 0.5px;
          }
        }
      }
    }

    .contact-info {
      margin-top: 10px;

      .contact-item {
        margin-bottom: 16px;
        display: flex;
        align-items: flex-start;

        .contact-label {
          width: 180px;
          font-size: 15px;
          color: #000;
        }

        .contact-value {
          font-size: 15px;
          flex: 1;
          color: #333;

          .call-center {
            font-size: 13px;
            color: red;
          }
        }
      }
    }
  }

  // 右侧省级微信服务群样式
  .wechat-groups {
    float: left;
    background-color: #fff;
    padding: 2.2rem 2.5rem;
    width: 50%;
    box-sizing: border-box;
    min-height: 30rem;
    height: auto;

    .section-title {
      color: #2a6fdb;
      font-size: 1.375rem;
      font-weight: 600;
      margin-bottom: 1.56rem;
      padding-bottom: 0.625rem;
      border-bottom: 1px solid #f0f0f0;
    }

    .province-grid {

      display: flex;
      flex-wrap: wrap;

      .province-item {
        font-weight: bold;
        padding: 0.94rem 0.625rem;
        min-width: 50px;
        margin-bottom: 0.625rem;
        margin-right: 0.625rem;
        text-align: center;
        border-radius: 4px;
        color: #333;
        font-size: 15px;
        transition: all 0.2s ease;
        cursor: pointer;

        &:hover {
          background-color: #f5f9ff;
          color: #2a6fdb;
        }

        &.active {
          background-color: #2a6fdb;
          color: white;
          font-weight: 500;
        }

        .province-item-trigger {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@keyframes icon-flip-once {
  0% {
    transform: scaleX(1);
  }

  50% {
    transform: scaleX(-1);
  }

  100% {
    transform: scaleX(1);
  }
}

.sys-banner {
  height: 6.375rem;
  background-image: linear-gradient(to right,
      /* 渐变方向：135度（右上到左下），可改为 to right/top/bottom left 等 */
      #dae4ef 0%,
      #e5edf4 50%,
      #edf3f6 100%
      /* 结束颜色 + 结束位置 */
    );
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1.25rem;
  margin-bottom: 1.25rem;

  .title {
    color: #004ac8;
    font-weight: bold;
    font-size: 1.5rem;
  }

  ul {
    display: flex;

    li {
      width: 6.875rem;
      height: 2.625rem;
      margin-right: 0.9rem;
      padding: 0 5px;
      line-height: 2.625rem;
      border-radius: 12px;
      background-color: #dee8f2;
      text-align: center;
      font-size: 1.125rem;
      color: #045ccd;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}

/* 平板：宽度 ≤ 768px */
@media (max-width: 900px) {
  .con-info {
    .service-center {
      width: 100%;
    }

    .wechat-groups {
      width: 100%;
      height: 45rem;
    }
  }


}
</style>
